import { useCallback, useState } from 'react'
import { RRule } from 'rrule'
import { TodoItem } from 'pages/todo/modules/TodoItem'

interface RecurrenceEditorState {
  isOpen: boolean
  todo: TodoItem | null
  startDate: Date | null
  options: any | null
  onSave: ((rrule: RRule, startDate: Date) => void) | null
}

interface UseRecurrenceEditorReturn {
  recurrenceEditorState: RecurrenceEditorState
  openRecurrenceEditor: (startDate: Date, options: any, onSave: (rrule: any) => void) => void
  closeRecurrenceEditor: () => void
  handleRecurrenceSave: (options: any, start?: Date) => void
}

/**
 * Recurrence editor 상태 관리 훅
 * @returns {Object} Recurrence editor 관련 상태와 핸들러들
 */
export const useRecurrenceEditor = (): UseRecurrenceEditorReturn => {
  const [recurrenceEditorState, setRecurrenceEditorState] = useState<RecurrenceEditorState>({
    isOpen: false,
    todo: null,
    startDate: null,
    options: null,
    onSave: null,
  })

  const openRecurrenceEditor = useCallback(
    (startDate: Date, options: any, onSave: (rrule: any) => void) => {
      setRecurrenceEditorState({
        isOpen: true,
        todo: null,
        startDate,
        options,
        onSave: (rrule: RRule, _startDate: Date) => onSave(rrule),
      })
    },
    [],
  )

  const closeRecurrenceEditor = useCallback(() => {
    setRecurrenceEditorState((prev) => ({ ...prev, isOpen: false }))
  }, [])

  const handleRecurrenceSave = useCallback(
    (options: any, start?: Date) => {
      if (recurrenceEditorState.onSave) {
        // Convert options to RRule if needed
        const rrule = options ? new RRule(options) : null
        recurrenceEditorState.onSave(rrule, start || recurrenceEditorState.startDate || new Date())
      }
      closeRecurrenceEditor()
    },
    [recurrenceEditorState.onSave, recurrenceEditorState.startDate, closeRecurrenceEditor],
  )

  return {
    recurrenceEditorState,
    openRecurrenceEditor,
    closeRecurrenceEditor,
    handleRecurrenceSave,
  }
}
